import React, {useEffect, useState} from 'react';
import {Row, Col, Image, Collapse, Modal} from "antd";
import './index.css'
import {getWalletInfo} from "../../../api/user";
import {useDispatch, useSelector} from 'react-redux';
import RechargeApp from './recharge'
import SettingEmailApp from "../settingEmail";
import {setCurrencies} from "../../../store/modules/user";
const {Panel} = Collapse
//钱包
const WalletInfoApp =(props)=>{
    //父组件传输
    const {homePageIndex,setHomePageIndex,handleCancelModel} = props
    var {currencies} = useSelector(state=>state.user)
    const dispatch = useDispatch()
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [walletInfo,setWalletInfo] = useState(null)
    const [currenciesSelf,setCurrenciesSelf] = useState(null)
    const [cards,setCards] = useState([])
    const [isRechargeOpen,setIsRechargeOpen] = useState(false)
    const handleCloseRechargeModel = ()=>{
        setIsRechargeOpen(false)
    }
    const handleOk = ()=>{
        getWalletInfoList()
        handleCloseRechargeModel()
    }
    var isLoad = false
       useEffect(()=>{
           if(!isLoad){
               isLoad = true
               setTimeout(()=>{isLoad=false},500)
               getWalletInfoList()
           }
    },[])
    const getWalletInfoList = ()=>{
        getWalletInfo().then(res=>{
            if(res.code === 200){
                setWalletInfo(res.data)
                setCurrenciesSelf(res?.data?.currencies[0] || null)
                setCards(res?.data?.cards || [])
                dispatch(setCurrencies(res?.data?.currencies[0]))
            }
        })
    }
    // const handleBuyMore = ()=>{
        // localStorage.setItem('ai-chat-his-homePageIndex',homePageIndex)
        // setHomePageIndex(9)
        // localStorage.getItem('ai-chat-homePageIndex',9)
        // handleCancelModel()
    // }
    return (
        <div className="WalletInfoApp">
            <div className={'mTitle'}>账户余额</div>
            <div className={'mMoney'}>￥<span>{currenciesSelf?.balance || 0}</span></div>
            <div className={'mBtn'}><span onClick={()=>setIsRechargeOpen(true)}>充值</span></div>
            <div className={'mLine'}></div>
            <div>
                {/* <a href='/common_q_and_a' target='_blank'>常见问题</a>
                <span style={{ display: 'inline-block', width: '50px' }}> </span> */}
                <a href='/pricing' target='_blank'>定价详情</a>
            </div>
            {/* <div className={'mSubTitle'}>我的卡包</div> */}
            {/* { */}
                {/* cards.length>0? */}
                {/* <div className={'mCard'}> */}
                    {/* <Row gutter={20}> */}
                        {/* <Col span={14}> */}
                            {/* <Image src={cards[0].card_image} width={175} preview={false}></Image> */}
                            {/*<div className={'cardImage'}>*/}
                            {/*    <Row>*/}
                            {/*        <Col span={18}>*/}
                            {/*            <div className={'cName'}>{cards[0].card_name}</div>*/}
                            {/*            <div className={'cTitle'}>(虚拟卡)</div>*/}
                            {/*        </Col>*/}
                            {/*        <Col span={6}>*/}
                            {/*            <div className={'cMoney'}>*/}
                            {/*                {cards[0].currency_code==='vCNY'?'￥':'$'}{cards[0]?.prepaid_amount}*/}
                            {/*            </div>*/}
                            {/*        </Col>*/}
                            {/*    </Row>*/}
                            {/*    <div className={'cLast'}>*/}
                            {/*        使用范围：*/}
                            {/*        <Image className={'imgMargin'} src={require('../../../assets/comm/ai-chat-openai.png')} width={20} preview={false}></Image>*/}
                            {/*        <Image className={'imgMargin'} src={require('../../../assets/comm/ai-chat-anthropic.png')} width={20} preview={false}></Image>*/}
                            {/*        <Image className={'imgMargin'} src={require('../../../assets/comm/ai-chat-google.png')} width={20} preview={false}></Image>*/}
                            {/*        <Image className={'imgMargin'} src={require('../../../assets/comm/ai-chat-meta.png')} width={20} preview={false}></Image>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        {/* </Col> */}
                        {/* <Col span={10} style={{textAlign:'left'}}> */}
                            {/* <div className={'cardM'}>卡片面值: {cards[0].currency_code==='vCNY'?'￥':'$'}{cards[0]?.prepaid_amount}</div> */}
                            {/* <div className={'cardP'}>卡内余额: {cards[0].currency_code==='vCNY'?'￥':'$'}{cards[0]?.balance}</div> */}
                            {/* <div className={'cardT'}>到期时间: {cards[0].expire_at.substring(0,10)}</div> */}
                        {/* </Col> */}
                    {/* </Row> */}
                {/* </div> */}
                {/* : */}
                {/* <div className={'mNoCard'}> */}
                    {/* <Row gutter={20}> */}
                        {/* <Col span={14}> */}
                            {/* <Image src={require('../../../assets/comm/llm-no.png')} width={180} preview={false}></Image> */}
                        {/* </Col> */}
                        {/* <Col span={10} style={{textAlign:'left'}}> */}
                            {/* <div className={'cardM'}>卡片面值: $-</div> */}
                            {/* <div className={'cardP'}>卡内余额: $-</div> */}
                            {/* <div className={'cardT'}>到期时间: -</div> */}
                        {/* </Col> */}
                    {/* </Row> */}
                {/* </div> */}
            {/* } */}

            {/* <div className={'mBuyMore mBtn'}><span onClick={handleBuyMore}>购买更多</span></div> */}
            <Modal footer={null} destroyOnClose={true} title="账户余额充值" open={isRechargeOpen} onCancel={handleOk} width={360}>
                <RechargeApp handleOk={handleOk} handleCloseRechargeModel={handleCloseRechargeModel} />
            </Modal>
        </div>
    )
}

export default WalletInfoApp
